import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const PaymentCancel = () => {
  const { lang } = useLang();
  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center" data-testid="payment-cancel-page">
      <XCircle size={40} />
      <h1 className="mt-4 text-2xl uc font-semibold">{lang === "ro" ? "Plată anulată" : "Payment cancelled"}</h1>
      <p className="mt-2 max-w-md font-mono text-xs uppercase leading-relaxed tracking-widest text-muted-foreground">
        {lang === "ro" ? "Nu a fost efectuată nicio plată. Coșul tău este intact." : "No payment was made. Your cart is intact."}
      </p>
      <Link to="/checkout" className="mt-6 border border-foreground px-6 py-3 font-mono text-[11px] uppercase tracking-widest hover:bg-foreground hover:text-white" data-testid="back-to-checkout">
        {lang === "ro" ? "Înapoi la checkout" : "Back to checkout"}
      </Link>
    </main>
  );
};

export default PaymentCancel;
